import { fmtDate } from "@/lib/formatDate";

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
    useGrouping: "always",
  }).format(n ?? 0);

export const num = (n) => new Intl.NumberFormat("it-IT").format(n ?? 0);

export const compact = (n) =>
  new Intl.NumberFormat("it-IT", { notation: "compact", maximumFractionDigits: 1 }).format(n ?? 0);

export const pct = (n) => `${(n ?? 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })}%`;

// Copia testo sicura (gestisce il rifiuto della Promise in iframe/permission-denied).
export const copyText = async (text) => {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(String(text)); return true; }
  } catch {}
  try {
    const ta = document.createElement("textarea");
    ta.value = String(text); ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
    return true;
  } catch { return false; }
};

export const dateShort = (iso) => fmtDate(iso);

export const dateIt = (iso) => fmtDate(iso);

// secondi -> m:ss
export const fmtDuration = (sec) => {
  if (sec == null) return "—";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};
